import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { fr, enUS } from "date-fns/locale";

/**
 * Returns the date-fns locale matching the current i18n language.
 */
export function useLocale() {
  const { i18n } = useTranslation();

  const locale = useMemo(() => {
    return i18n.language?.startsWith("fr") ? fr : enUS;
  }, [i18n.language]);

  return locale;
}
